import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { themeColor, THEME_LIGHTGREY } from '../../styles/basics/colors';

const StHorizontalRuler = styled.div<{ heightSpacer: number }>`
    display: block;
    padding-bottom: ${props => `${props.heightSpacer / 2}px`};
    border-bottom: 1px solid ${themeColor(THEME_LIGHTGREY)};
    margin-bottom: ${props => `${props.heightSpacer / 2}px`};
`;

const HorizontalRuler = props => {
    return <StHorizontalRuler heightSpacer={props.heightSpacer} />;
};

HorizontalRuler.propTypes = {
    heightSpacer: PropTypes.number.isRequired
};

export default HorizontalRuler;
